export default __webpack_public_path__ + "static/media/brand_logo.58e53f3f.svg";